import React from 'react';
import { ChevronDown, RefreshCw } from 'lucide-react';
import { useTierPortfolio } from '../../hooks/useTierPortfolio';
import TierSpectrumRail from './TierSpectrumRail';

const TierPortfolioHeader: React.FC = () => {
  const {
    accounts,
    accountsLoading,
    selectedAccountId,
    setSelectedAccountId,
    tierFilter,
    setTierFilter,
    accountContext,
    contextLoading,
    refreshContext,
  } = useTierPortfolio();

  return (
    <div className="border-b border-slate-800 bg-gradient-to-r from-slate-950 via-slate-900 to-slate-950 text-white shadow-md">
      <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">
              Portfolio tiers
            </p>
            <h2 className="text-lg font-semibold text-white">
              Six-objective capital stack
            </h2>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <label className="sr-only" htmlFor="account-scope">
              Account scope
            </label>
            <div className="relative">
              <select
                id="account-scope"
                disabled={accountsLoading || accounts.length === 0}
                value={selectedAccountId ?? ''}
                onChange={(e) => setSelectedAccountId(e.target.value || null)}
                className="appearance-none rounded-lg border border-slate-600 bg-slate-800 py-2 pl-3 pr-9 text-sm text-white focus:border-primary-400 focus:outline-none focus:ring-1 focus:ring-primary-400"
              >
                {accounts.length === 0 ? (
                  <option value="">No accounts</option>
                ) : (
                  accounts.map((a) => (
                    <option key={a.id} value={a.id}>
                      {a.nickname}
                    </option>
                  ))
                )}
              </select>
              <ChevronDown className="pointer-events-none absolute right-2 top-2.5 h-4 w-4 text-slate-400" />
            </div>
            <button
              type="button"
              onClick={() => refreshContext()}
              disabled={contextLoading}
              className="inline-flex items-center rounded-lg border border-slate-600 px-3 py-2 text-sm text-slate-200 hover:bg-slate-800 disabled:opacity-50"
            >
              <RefreshCw
                className={`mr-1.5 h-4 w-4 ${contextLoading ? 'animate-spin' : ''}`}
              />
              Refresh
            </button>
          </div>
        </div>
        <TierSpectrumRail
          context={accountContext}
          filter={tierFilter}
          onFilterChange={setTierFilter}
          accountId={selectedAccountId ?? undefined}
          showInlineCharts
        />
      </div>
    </div>
  );
};

export default TierPortfolioHeader;
